import { render, staticRenderFns } from "./StarVehicle.vue?vue&type=template&id=278792ba&scoped=true&"
import script from "./StarVehicle.vue?vue&type=script&lang=js&"
export * from "./StarVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278792ba",
  null
  
)

export default component.exports